import React from 'react';
import cx from 'clsx';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import { Product, ProductCurriculum } from 'types/schema-generated-types';
import { getDisplayName } from 'utilities/product-utils';

interface LicenseInformationCardProps {
  product: Product;
  productCurriculum?: ProductCurriculum;
  className?: string;
  actionButton?: React.ReactNode;
}

const useStyles = makeStyles(theme => ({
  container: {
    border: `1px solid ${theme.palette.divider}`,
    padding: `${theme.spacing(1)}px ${theme.spacing(1)}px`,
    minWidth: 0
  },
  textContainer: {
    overflow: 'hidden',
    paddingLeft: theme.spacing(1)
  },
  logo: { height: 36 },
  text: {
    fontWeight: theme.typography.fontWeightMedium,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  },
  button: {
    marginLeft: 'auto',
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1)
  }
}));

const LicenseInformationCard: React.FC<LicenseInformationCardProps> = ({
  product,
  productCurriculum,
  className,
  actionButton
}) => {
  const classes = useStyles();

  const iconUrl = productCurriculum?.iconUrl ?? product.iconUrl;

  return (
    <Grid
      container
      wrap="nowrap"
      component={Paper}
      alignItems="center"
      elevation={0}
      className={cx(classes.container, className)}
    >
      {iconUrl && (
        <img
          src={iconUrl}
          alt={getDisplayName(product, productCurriculum)}
          className={classes.logo}
        />
      )}
      <Grid item className={classes.textContainer}>
        <Typography variant="subtitle1" className={classes.text} component="p">
          {product.name}
        </Typography>
        {productCurriculum && (
          <Typography variant="body1" component="p">
            {productCurriculum.name} ({productCurriculum.code})
          </Typography>
        )}
      </Grid>
      {actionButton && (
        <Grid item className={classes.button}>
          {actionButton}
        </Grid>
      )}
    </Grid>
  );
};

export default LicenseInformationCard;
